<div class="title" mat-dialog-title>
  <h2>Registrer MobilPant</h2>
  <mat-icon matDialogClose [svgIcon]="IconNames.ice_close" />
</div>
<div class="trade-in-content" mat-dialog-content>
  @if (selectedStep() < 1) {
    <app-information-disclosure [inquiredInfoDisclosure]="'howTradeInWorks'" />
  } @else {
    <div class="trade-in-information">
      <app-trade-in-mobile-phone-details />
      @if (inquiredControl) {
        <app-control-inquiry [inquiredControl]="inquiredControl" />
      }
    </div>
  }

  @if (isCalculatingTradeInValue()) {
    <div class="calculation-loader">
      <app-spinner />
      Beregner takst
    </div>
  } @else if (!showConfirmationStep) {
    <app-trade-in-stepper (infoClicked)="inquiredControl = $event" (submitClicked)="createTradeInVoucher()" />
  } @else {
    <app-trade-in-confirmation (backClicked)="onConfirmationBackClicked()" />
  }
</div>
